import { apiProvider } from './utilities/Provider';

const getUsers = () =>
    apiProvider.get('agency/account/users');

const inviteUser = ({ firstName, lastName, email }) =>
    apiProvider.post('agency/account/users/invite', { firstName, lastName, email });

const deactivateUser = (id) =>
    apiProvider.patch(`agency/account/users/${id}/deactivate`, {});

const AccountUsersService = { getUsers, inviteUser, deactivateUser };

export default AccountUsersService;
